import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProject } from "../Model/ProposalProject";

export async function createProposalProject(data) {
	let response = await getAPIResponse("/v1/proposal-project", data, "POST");
	if (response === null) {
		return null;
	}
	let proposalProject = ProposalProject.createFromResponseData(response);
	return proposalProject;
}